import { useState, useEffect } from "react";
import axios from "axios";
import { DropdownProps } from "../../types/Dropdown";
import { MAIN_URL } from "../../config";
interface Response {
  items: DropdownProps;
}

interface UseStateInfoResponse {
  data: Response | null;
  loading: boolean;
  error: string | null;
}

const useValues = (
  selected: { label: string; value: string }[],
  textId?: string,
  filterId?: string
): UseStateInfoResponse => {
  const [data, setData] = useState<Response | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        let params: any = {
          metric: selected[0].value,
        };
        if (textId) {
          params = {
            metric: selected[0].value,
            textId: textId,
          };
        } else {
          params = {
            metric: selected[0].value,
            filterId: filterId,
          };
        }
        const response = await axios.get(
          `https://oparl-textprovider-production.up.railway.app/getvalues`,
          //`http://localhost:1080/getvalues`,
          { params }
        );
        setData(response.data);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          setError(`Error: ${err.response.statusText}`);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selected, textId, filterId]);

  return { data, loading, error };
};

export default useValues;
